import React from "react";

import { Trans } from "@lingui/macro";

import { Button, Typography } from "@mui/material";

import { LogoMenuItem, MenuItemRow } from "./styles";

interface PushMenuItemProps {
  disabled: boolean;
  displayName: string;
  imgSrc: string;
  isConnected: boolean;
  onClickAdd: () => void;
  onClick: () => void;
}

export const PushMenuItem = ({
  disabled,
  displayName,
  imgSrc,
  isConnected,
  onClickAdd,
  onClick,
}: PushMenuItemProps) => {
  return (
    <LogoMenuItem disabled={disabled} onClick={onClick}>
      <MenuItemRow>
        <img src={imgSrc} alt={displayName} />
        <Typography variant="bodySecondaryReg" sx={{ flex: 1 }}>
          {displayName}
        </Typography>
        {!isConnected && (
          <Button variant="contained" color="primary" onClick={onClickAdd}>
            <Trans>Add</Trans>
          </Button>
        )}
      </MenuItemRow>
    </LogoMenuItem>
  );
};
